import { injectIntl } from 'react-intl';
import LoyaltyLoggedOutModal from './LoyaltyLoggedOutModal';

export default injectIntl(LoyaltyLoggedOutModal);
